import { useSnackbarStore } from '@/services/snackbarStore';

// eslint-disable-next-line import/prefer-default-export
export function useSnackbarHandler() {
  const {
    showSnackbar
  } = useSnackbarStore();
  const handleError = (err, options = {}) => {
    const errorMessage = typeof err === 'string' ? err : err.response?.data?.message || err.body?.message || err.message;
    console.error('Toast error:', errorMessage);
    showSnackbar('error', errorMessage, options);
  };
  const handleSuccess = (message, options = {}) => {
    const successMessage = typeof message === 'string' ? message : message.message || message.response.data.message;
    console.log('Toast success:', message);
    showSnackbar('success', successMessage, options);
  };
  const handleWarning = (message, options = {}) => {
    const successMessage = typeof message === 'string' ? message : message.message || message.response.data.message;
    showSnackbar('warning', successMessage, options);
  };
  const handleInfo = (message, options = {}) => {
    const infoMessage = typeof message === 'string' ? message : message.message || message.response.data.message;
    console.info('Toast info:', infoMessage);
    showSnackbar('info', infoMessage, options);
  };
  return {
    handleError,
    handleSuccess,
    handleWarning,
    handleInfo
  };
}